/* Publish by EComposer at 2026-10-02 08:56:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mntqsoh1hl8"]=  window.__ectimmers["ecom-mntqsoh1hl8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-mntqsoh1hl8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mntqsoh1hl8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sr8zxwlxlj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sr8zxwlxlj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6uxkl3zex8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6uxkl3zex8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypso61dtb38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypso61dtb38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rygi7hey4w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rygi7hey4w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1w644k17z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1w644k17z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utrc7230xv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utrc7230xv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-she23szbot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-she23szbot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jbrg46zw2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jbrg46zw2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p82tgy8e0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p82tgy8e0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lx1jvnvpojf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lx1jvnvpojf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fhhfvbg3dpb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fhhfvbg3dpb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ax5slvpjih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ax5slvpjih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd24a2rl8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd24a2rl8y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kl0ddey9sgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kl0ddey9sgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlqp8ncinmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlqp8ncinmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e01n2n925fi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e01n2n925fi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azub9l45pb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azub9l45pb5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ki83n2pgihd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ki83n2pgihd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lyd70ps13sl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lyd70ps13sl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey6yi2cexg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey6yi2cexg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrwbgmrqf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrwbgmrqf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8krp5r2zjxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8krp5r2zjxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4avu29wi6rf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4avu29wi6rf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ce25uxt3p7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ce25uxt3p7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oybx57vcc9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oybx57vcc9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovxbotcioq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovxbotcioq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khvvco088iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khvvco088iq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sxnq1kwwtdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sxnq1kwwtdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1x8d5uoah3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1x8d5uoah3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfx80ovx09j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfx80ovx09j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsa249o7hd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsa249o7hd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybyxah5sdos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybyxah5sdos', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgw0knak4y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgw0knak4y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9x14kg3d49d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9x14kg3d49d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-94jowe35zdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-94jowe35zdb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nmf9ie3rx1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nmf9ie3rx1c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3mvp689l9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3mvp689l9w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99e5n5heo8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99e5n5heo8v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-em5uoqilbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-em5uoqilbo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sm260wsf7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sm260wsf7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbjom7z4ior').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbjom7z4ior', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-utaeomytpbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utaeomytpbr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kc1d1scvzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kc1d1scvzp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l3xxdwwhu2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l3xxdwwhu2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-236e9wqssz6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-236e9wqssz6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzv9pf33rzp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzv9pf33rzp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbb7rhzj3mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbb7rhzj3mo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxji68a4hvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxji68a4hvi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jq4v7z3paq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jq4v7z3paq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ar5cqy5mnls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ar5cqy5mnls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhcpgrzna0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhcpgrzna0r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-se94uzsq4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-se94uzsq4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6rnflledfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6rnflledfe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5p0s7jubpiy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5p0s7jubpiy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gj8p586tmgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gj8p586tmgf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-433id0gr5k3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-433id0gr5k3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ykbh149zcg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykbh149zcg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7j9dmpcams6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7j9dmpcams6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5dg9g2n7u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5dg9g2n7u', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qtm7jdy4jq"]=  window.__ectimmers["ecom-qtm7jdy4jq"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-qtm7jdy4jq"]["frjllnvg6"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-qtm7jdy4jq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtm7jdy4jq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m6730irz5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6730irz5n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qhv8r1g239').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qhv8r1g239', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmvsgblawos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmvsgblawos', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtx9wewpta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtx9wewpta', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7iks2um98t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7iks2um98t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8khjbamlrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8khjbamlrq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eydllivk7bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eydllivk7bc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxvrg4088a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxvrg4088a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54menobm9vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54menobm9vt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lsu0w3ez6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lsu0w3ez6a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bd2cmpyepqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bd2cmpyepqs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93gnu8aycz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93gnu8aycz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fq6t199fr5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fq6t199fr5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g9l764obsp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g9l764obsp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-luy384iju5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-luy384iju5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9xzyc3uttxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9xzyc3uttxe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oql7yiuii6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oql7yiuii6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ca8ix9bobvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ca8ix9bobvf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnsucjiw02s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnsucjiw02s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a8vksaem2vc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a8vksaem2vc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9oqbn4k6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9oqbn4k6u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kvtquuv9fh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvtquuv9fh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hn0jw7z0tuf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn0jw7z0tuf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-adrfg0ecv4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-adrfg0ecv4h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lvkjau1jf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lvkjau1jf4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7399buq0c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7399buq0c9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iqytaprsx4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqytaprsx4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-voxd9505fne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-voxd9505fne', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wo6m9cj33wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wo6m9cj33wh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6ou48u37o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6ou48u37o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ubo0xh3b0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ubo0xh3b0g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g3dm812tlle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g3dm812tlle', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3scrf99zx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3scrf99zx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbi2fsc90h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbi2fsc90h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqbulyb4ir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqbulyb4ir', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j3smfo75d5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j3smfo75d5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ntzahlmyw3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ntzahlmyw3', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1d0a4riya59"]=  window.__ectimmers["ecom-1d0a4riya59"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-1d0a4riya59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d0a4riya59', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hthz5ulknk9"]=  window.__ectimmers["ecom-hthz5ulknk9"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-hthz5ulknk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hthz5ulknk9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ree7fckfu1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ree7fckfu1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjxtsayitd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjxtsayitd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-krsei3291e9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-krsei3291e9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5rhbjcwymlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rhbjcwymlu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsryiq3iu5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsryiq3iu5b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dspezp6rsha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dspezp6rsha', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kr94d4u45i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kr94d4u45i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifela4ovk0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifela4ovk0j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdpc626bcgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdpc626bcgk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1lzht6gbso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1lzht6gbso', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i4xlv4ydn9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i4xlv4ydn9m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5d6o60wvdi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5d6o60wvdi', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwy7jy28k1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwy7jy28k1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pxqs25aw89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pxqs25aw89', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f21y7e4s98i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f21y7e4s98i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ta294j1dxud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ta294j1dxud', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-psugibz6g9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-psugibz6g9j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cuyq29ub43f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cuyq29ub43f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1jzdmu8rsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1jzdmu8rsl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vpvoj3zrvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vpvoj3zrvd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tymlk3cwo3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tymlk3cwo3p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3j3qf9fac9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3j3qf9fac9e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bjo2b8mrr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bjo2b8mrr8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z1gjzi1fbel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z1gjzi1fbel', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fd97ga8upa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fd97ga8upa', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5000wdr2ek2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5000wdr2ek2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amexbqgdv6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amexbqgdv6l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8ni9zqbvj9m"]=  window.__ectimmers["ecom-8ni9zqbvj9m"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,o=this.settings.autoplay,n=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const f=t.querySelector(".ecom-element_video-iframe");n&&setTimeout(function(){b(f)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){o&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),o&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-8ni9zqbvj9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ni9zqbvj9m', settings: {"loop":false,"autoplay":false,"click_to_play_pause":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}